import React from "react"
import { Link } from "gatsby"

import ShareList from "./shareList"

const PostCard = ({
  to,
  image,
  time,
  title,
  description,
  shareUrl,
  isHorizontal,
  isHeader,
  isNew,
  isPL,
}) => {
  const isBrowser = typeof window !== "undefined"
  const location = isBrowser ? window.location.origin : null

  const ImageType = to ? Link : "span"
  const HeadingType = isHeader ? "h1" : "h2"

  return (
    <div
      className={`post-card${isHorizontal ? " post-card--horizontal" : ""}${
        isHeader ? " post-card--header" : ""
      }`}
    >
      <div className="post-card__thumbnail">
        <ImageType
          className="post-card__thumbnail-image"
          to={to}
          style={{
            backgroundImage: `url(${image})`,
          }}
        />
      </div>
      <div className="post-card__body">
        <div className="post-card__content">
          <div className="post-card__content-meta">
            <time>{time}</time>
            {isNew && <span>{isPL ? "Najnowszy wpis" : "Latest entry"}</span>}
          </div>
          <HeadingType>{to ? <Link to={to}>{title}</Link> : title}</HeadingType>
          {description && (
            <div
              className="post-card__content-description"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
          {to && (
            <div className="post-card__content-link">
              <Link className="btn-custom btn-custom--arrow" to={to}>
                {isPL ? "Czytaj więcej" : "Read more"}
              </Link>
            </div>
          )}
          {shareUrl && (
            <div className="post-card__content-share">
              <ShareList
                label={isPL ? "Udostępnij" : "Share"}
                url={`${location}${shareUrl}`}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PostCard
